/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NextAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaIconArrowForward from 'DesignSystem/Svgs/TysiaIconArrowForward/index'



/** @type {import('Simple/types.js').View} */
export default function NextAction({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/NextAction",
  onClickNextAction,
  nextActionDisabled
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={onClickNextAction}
 size="small"
 type="ghost"
 marginRight={dtSpaceXxs}
 title="Next"
 disabled={nextActionDisabled}
>
{childProps => (
<TysiaIconArrowForward
{...childProps}
  viewPath={`${viewPath}/TysiaIconArrowForward`}
 width={12}
 height={12}
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}